import { TimePicker2 } from '@alifd/next';
import wrapper from './next-wrapper';
const FormTimePicker = wrapper(TimePicker2, 'CbayelFormTimePicker');
export default FormTimePicker;
